import { render } from "./PropertyView.vue?vue&type=template&id=46194978&scoped=true"
import script from "./PropertyView.vue?vue&type=script&lang=js"
export * from "./PropertyView.vue?vue&type=script&lang=js"

import "./PropertyView.vue?vue&type=style&index=0&id=46194978&lang=scss&scoped=true"

import exportComponent from "/home/ak/projects/ysm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46194978"]])

export default __exports__